<template>
  <div class="col-sm-12" id="addFormModal" tabindex="-1">
    <div class="header">
      <span class="title">Add Form</span>
      <span @click="closeModal" class="btn-close float-right">&times;</span>
    </div>
    <div class="forms-wrapper">
      <form>
        <div class="row">
          <div class="col-sm-6">
            <div class="form-group">
              <label for="name">Name</label>
              <input type="text" :class="['form-control', invalidFields.indexOf('name') === -1 ? '' : 'invalid']" id="name" placeholder="Name of the form" v-model="name">
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group">
              <label for="title">Title</label>
              <input type="text" :class="['form-control', invalidFields.indexOf('title') === -1 ? '' : 'invalid']" id="title" placeholder="Title of the form" v-model="title">
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6">
            <div class="form-group">
              <label for="viewer-url">Viewer URL</label>
              <input type="text" :class="['form-control', invalidFields.indexOf('viewer_url') === -1 ? '' : 'invalid']" id="viewer_url" placeholder="The path to the SVG and thumbnail output" v-model="viewer_url">
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group">
              <label for="status">Status</label>
              <select class="form-control" id="status" v-model="status">
                <option value="DEV">DEV</option>
                <option value="Enabled">Enabled</option>
                <option value="Disabled">Disabled</option>
              </select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-4">
            <div class="form-group">
              <label for="revision-date">Revision Date</label>
              <input type="text" v-mask="'##/##/####'" :class="['form-control', invalidFields.indexOf('revisionDate') === -1 ? '' : 'invalid']" id="revisionDate" placeholder="01/31/2018" v-model="revisionDate">
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label for="expiration-date">Expiration Date</label>
              <input type="text" v-mask="'##/##/####'" :class="['form-control', invalidFields.indexOf('expirationDate') === -1 ? '' : 'invalid']" id="expirationDate" placeholder="12/31/2018" v-model="expirationDate">
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label for="version">Version</label>
              <input type="number" :class="['form-control', invalidFields.indexOf('version') === -1 ? '' : 'invalid']" id="version" v-model="version">
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4">
            <div class="form-group">
              <label for="library">Library</label>
              <select class="form-control" @change="setPracticeAreaSections" id="library" v-model="practiceArea">
                <option v-for="(area, index) in $store.state.practiceAreas"
                  :key="index"
                  :value="area.name">
                  {{ area.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-sm-4" v-if="!Object.keys(globalTemplate).length">
            <input accept=".json" type="file" id="selectFiles" value="Import" />
            <input type="button" class="btn btn-info" @click="getJsonFile" value="Upload Template"/>
          </div>
          <div v-else class="col-sm-4">
            <h4>Global Template Ready</h4>
            <p>Processed {{ totalFields }} fields in {{ totalPages}} pages.</p>
          </div>
          <div class="col-sm-4">
            <div class="form-group">
              <label for="primaId">Prima ID</label>
              <input type="number" :class="['form-control', invalidFields.indexOf('primaId') === -1 ? '' : 'invalid']" id="primaId" v-model="primaId">
            </div>
          </div>
        </div>
        <div class="row justify-content-between">
          <div class="col-sm-4">
            <div class="form-group">
              <label for="practice-area-section">Sections</label>
              <select class="form-control" id="practice-area-section" v-model="practiceAreaSection">
                <option v-for="(section, index) in practiceAreaSections"
                  :key="index"
                  :value="section"
                  :selected="selectPracticeAreaSection(section)">
                  {{ section }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-sm-4">
            <div class="form-group">
              <label for="enable-for-questionnaire">Enable for Questionnaire</label>
              <br>
              <input id="enable-for-questionnaire" @click="enableForQ = !enableForQ" :checked="enableForQ" type="checkbox">
            </div>
          </div>
        </div>

        <div class="row justify-content-between">
          <div class="col-sm-4">
            <div class="form-group">
              <label for="practice-area-tag">Practice Area</label>
              <search-select v-model="practiceAreaTag" :multiple="true" :options="tagsFormPA"/>
            </div>
          </div>

          <div class="col-sm-4 pull-right">
            <div class="form-group">
              <label for="internal-tag">Internal Tag</label>
              <br>
              <search-select v-model="internalTag" :taggable="true" :multiple="true" :options="tagsFormInternal"/>
            </div>
          </div>
        </div>
      </form>

      <h2>Roles</h2>
      <form>
        <div class="row">
          <div class="col-sm-5">
            <div class="form-group">
              <label for="role">Role</label>

              <search-select id="addFormRole1" v-model="role1" label="name" :options="$store.state.formRoles"/>

            </div>
          </div>
          <div class="col-sm-5">
            <div class="form-group">
              <label for="prefix">Prefix</label>
              <input type="text" class="form-control" id="prefix" v-model="prefix1">
            </div>
          </div>
          <div v-if="role1 !== '' && role1 !== '0' && role1._id !== undefined" class="col-sm-2" style="margin-top:12px;">
            <label ></label>
            <input type="button" value="Max Items" @click="showMaxItemsModal('role1')" id="maxRole" class="btn btn-sm btn-primary btn-block">
          </div>
        </div>

        <div class="row">
          <div class="col-sm-5">
            <div class="form-group">
              <label for="role2">Role 2</label>

              <search-select id="addFormRole2" v-model="role2" label="name" :options="$store.state.formRoles"/>

            </div>
          </div>
          <div class="col-sm-5">
            <div class="form-group">
              <label for="prefix2">Prefix 2</label>
              <input type="text" class="form-control" id="prefix2" v-model="prefix2">
            </div>
          </div>
          <div v-if="role2 !== '' && role2 !== '0' && role2._id !== undefined" class="col-sm-2" style="margin-top:12px;">
            <label ></label>
            <input type="button" value="Max Items" @click="showMaxItemsModal('role2')" id="maxRole2" class="btn btn-sm btn-primary btn-block">
          </div>
        </div>

        <div class="row">
          <div class="col-sm-5">
            <div class="form-group">
              <label for="role3">Role 3</label>

              <search-select id="addFormRole3" v-model="role3" label="name" :options="$store.state.formRoles"/>

            </div>
          </div>
          <div class="col-sm-5">
            <div class="form-group">
              <label for="prefix3">Prefix 3</label>
              <input type="text" class="form-control" id="prefix3" v-model="prefix3">
            </div>
          </div>
          <div v-if="role3 !== '' && role3 !== '0' && role3._id !== undefined" class="col-sm-2" style="margin-top:12px;">
            <label></label>
            <input type="button" value="Max Items" @click="showMaxItemsModal('role3')" id="maxRole3" class="btn btn-sm btn-primary btn-block">
          </div>
        </div>

        <div class="row">
          <div class="col-sm-5">
            <div class="form-group">
              <label for="role4">Role 4</label>

              <search-select id="addFormRole4" v-model="role4" label="name" :options="$store.state.formRoles"/>

            </div>
          </div>
          <div class="col-sm-5">
            <div class="form-group">
              <label for="prefix4">Prefix 4</label>
              <input type="text" class="form-control" id="prefix4" v-model="prefix4">
            </div>
          </div>
          <div v-if="role4 !== '' && role4 !== '0' && role4._id !== undefined" class="col-sm-2" style="margin-top:12px;">
            <label></label>
            <input type="button" value="Max Items" @click="showMaxItemsModal('role4')" id="maxRole4" class="btn btn-sm btn-primary btn-block">
          </div>
        </div>

        <div class="row">
          <div class="col-sm-5">
            <div class="form-group">
              <label for="role5">Role 5</label>

              <search-select id="addFormRole5" v-model="role5" label="name" :options="$store.state.formRoles"/>

            </div>
          </div>
          <div class="col-sm-5">
            <div class="form-group">
              <label for="prefix5">Prefix 5</label>
              <input type="text" class="form-control" id="prefix5" v-model="prefix5">
            </div>
          </div>
          <div v-if="role5 !== '' && role5 !== '0' && role5._id !== undefined" class="col-sm-2" style="margin-top:12px;">
            <label for=""></label>
            <input type="button" value="Max Items" @click="showMaxItemsModal('role5')" id="maxRole5" class="btn btn-sm btn-primary btn-block">
          </div>
        </div>

        <div class="row">
          <div class="col-sm-5">
            <div class="form-group">
              <label for="role6">Role 6</label>

              <search-select id="addFormRole6" v-model="role6" label="name" :options="$store.state.formRoles"/>

            </div>
          </div>
          <div class="col-sm-5">
            <div class="form-group">
              <label for="prefix6">Prefix 6</label>
              <input type="text" class="form-control" id="prefix6" v-model="prefix6">
            </div>
          </div>
          <div v-if="role6 !== '' && role6 !== '0' && role6._id !== undefined" class="col-sm-2" style="margin-top:12px;">
            <label for=""></label>
            <input type="button" value="Max Items" @click="showMaxItemsModal('role6')" id="maxRole6" class="btn btn-sm btn-primary btn-block">
          </div>
        </div>

        <div class="row">
          <div class="col-sm-5">
            <div class="form-group">
              <label for="role7">Role 7</label>

              <search-select id="addFormRole7" v-model="role7" label="name" :options="$store.state.formRoles"/>

            </div>
          </div>
          <div class="col-sm-5">
            <div class="form-group">
              <label for="prefix7">Prefix 7</label>
              <input type="text" class="form-control" id="prefix7" v-model="prefix7">
            </div>
          </div>
          <div v-if="role7 !== '' && role7 !== '0' && role7._id !== undefined" class="col-sm-2" style="margin-top:12px;">
            <label for=""></label>
            <input type="button" value="Max Items" @click="showMaxItemsModal('role7')" id="maxRole7" class="btn btn-sm btn-primary btn-block">
          </div>
        </div>

        <div class="row">
          <div class="col-sm-5">
            <div class="form-group">
              <label for="role">Role 8</label>

              <search-select id="addFormRole8" v-model="role8" label="name" :options="$store.state.formRoles"/>

            </div>
          </div>
          <div class="col-sm-5">
            <div class="form-group">
              <label for="prefix8">Prefix 8</label>
              <input type="text" class="form-control" id="prefix8" v-model="prefix8">
            </div>
          </div>
          <div v-if="role8 !== '' && role8 !== '0' && role8._id !== undefined" class="col-sm-2" style="margin-top:12px;">
            <label for=""></label>
            <input type="button" value="Max Items" @click="showMaxItemsModal('role8')" id="maxRole8" class="btn btn-sm btn-primary btn-block">
          </div>
        </div>
      </form>

      <button class="btn btn-success" @click="uploadForm">Add Form</button>

      <div class="scroll-padding"></div>
    </div>

    <max-items-modal
      v-if="isMaxItemsModal === true"
      @close="isMaxItemsModal = false"
      :role="currentRole"
      :maxItems="maxItems"
      @update-maxitems="updateMaxItems"
    />
  </div>
</template>

<script>
import MaxItemsModal from './MaxItemsModal'

import SearchSelect from '../searchSelect/SearchSelect.vue'

export default {
  name: 'add-form-modal',

  data () {
    return {
      jsonData: {},

      globalTemplate: {},
      totalPages: 0,
      totalFields: 0,

      invalidFields: [],

      name: '',
      title: '',
      viewer_url: '',
      status: 'DEV',
      revisionDate: '',
      expirationDate: '',
      version: 0,
      primaId: '',
      practiceArea: 'Immigration',
      practiceAreaSections: [],
      practiceAreaSection: '',
      role1: 'None',
      prefix1: '',
      role2: 'None',
      prefix2: '',
      role3: 'None',
      prefix3: '',
      role4: 'None',
      prefix4: '',
      role5: 'None',
      prefix5: '',
      role6: 'None',
      prefix6: '',
      role7: 'None',
      prefix7: '',
      role8: 'None',
      prefix8: '',

      isMaxItemsModal: false,
      currentRole: '',
      maxItems: {},
      allRolesMaxItems: {},

      enableForQ: false,

      tagsFormPA: [],
      tagsFormInternal: [],

      practiceAreaTag: [],
      internalTag: [],

      formDataBulk: null,

      massiveFormIds: [],
      massiveJsonData: [],
      massiveFormDataBulk: [],
      isBulkAction: false,
      contFormsBulkAction: 0
    }
  },

  props: {
    formData: {
      type: Object
      // required: true
    }
  },

  components: {
    MaxItemsModal,
    SearchSelect
  },

  mounted () {
    this.$store.state.practiceAreas.forEach(practiceArea => {
      if (this.practiceArea === practiceArea.name) this.practiceAreaSections = practiceArea.sections
    })

    if (this.practiceAreaSections === undefined) {
      this.practiceAreaSections = this.$store.state.practiceAreas[4].sections
    }

    this.practiceAreaSection = this.practiceAreaSections[0]

    this.getFormTags()
  },

  methods: {
    getFormTags () {
      // GET FORM TAGS

      this.$store.dispatch('getFormTags', {
        tagType: 'practiceArea'
      }).then(response => {
        if (response.data !== undefined && response.data !== null) this.tagsFormPA = response.data
      })

      this.$store.dispatch('getFormTags', {
        tagType: 'internal'
      }).then(response => {
        if (response.data !== undefined && response.data !== null) this.tagsFormInternal = response.data
      })
    },

    closeModal () {
      this.$parent.$emit('closeModal')
    },

    getJsonFile () {
      const files = document.getElementById('selectFiles').files

      if (files.length !== 1) {
        return false
      }

      var fr = new FileReader()
      fr.readAsText(files.item(0))

      let that = this
      fr.onload = function (e) {
        that.jsonData = JSON.parse(e.target.result)
        that.createTemplate()
      }
    },

    createTemplate () {
      let templateData = {
        formId: null,
        filename: this.jsonData['filename'],
        name: 'default',
        pages: {},
        fieldGroups: {}
      }

      for (const pageNum in this.jsonData['pages']) {
        if (this.jsonData.pages.hasOwnProperty(pageNum)) {
          this.totalPages++
          const pageFields = this.jsonData.pages[pageNum]['pageFields']

          if (typeof templateData.pages[pageNum] === 'undefined') {
            templateData.pages[pageNum] = []
          }

          for (const fieldName in pageFields) {
            if (pageFields.hasOwnProperty(fieldName)) {
              const field = pageFields[fieldName]

              let newData = {
                id: fieldName,
                name: fieldName,
                model: '',
                value: '',
                type: field.fieldType.toLowerCase(),
                tabOrder: field.tabOrder,
                x: field.x,
                y: field.y,
                width: field.width,
                height: field.height,
                maskType: '',
                translations: {}
              }

              if (typeof field.choiceData !== 'undefined' && typeof field.choiceData === 'string') {
                newData['choiceData'] = field.choiceData.slice(1, -1).split(',')
              }

              templateData.pages[pageNum].push(newData)
              this.totalFields++
            }
          }
        }
      }

      this.globalTemplate = templateData
    },

    uploadDefaultTemplate () {
      const apiUrl = this.$store.state.apiUrl

      if (!this.globalTemplate.pages) {
        this.globalTemplate.name = 'default'
      }

      this.axios.post(apiUrl + 'template/add', this.globalTemplate).then(response => {
        if (response.data.success) {
          this.uploadDefaultQuestionnaire(response.data.id)
        } else {
          this.$bus.emit('addNotification', {
            title: 'Template Error',
            body: 'There was an error adding the default template to this form. Please review the data and try again',
            type: 'error'
          })
        }
      })
      this.$store.commit('setLastSaved', Date.now())
    },

    uploadDefaultQuestionnaire (templateId) {
      const apiUrl = this.$store.state.apiUrl
      this.axios.post(apiUrl + 'questionnaire/add', {templateId: templateId}).then(response => {
        if (response.data.success) {
          this.$store.commit('addQuestionnaire', {
            '_id': response.data.id,
            templateId: templateId
          })

          this.$store.commit('addQuestionnaire', {
            index: 'default',
            data: {
              '_id': response.data.id,
              templateId: templateId,
              data: {}
            }
          })

          this.uploadGlobalTemplate()
          console.log('Success!')
        } else {
          this.$bus.emit('addNotification', {
            title: 'Questionnaire Error',
            body: 'There was an error adding the default questionnaire to this form. Please review the data and try again',
            type: 'error'
          })
        }
      })
      this.$store.commit('setLastSaved', Date.now())
    },

    uploadGlobalTemplate () {
      this.globalTemplate['name'] = 'global'
      const apiUrl = this.$store.state.apiUrl
      this.axios.post(apiUrl + 'template/add', this.globalTemplate).then(response => {
        if (response.data.success) {
          this.$bus.emit('addNotification', {
            title: 'Form Created',
            body: 'The form was created successfully',
            type: 'success'
          })
          this.$parent.$emit('closeModal')
        } else {
          this.$bus.emit('addNotification', {
            title: 'Template Error',
            body: 'There was an error adding the global template to this form. Please review the data and try again',
            type: 'error'
          })
        }
      })
    },

    uploadForm () {
      let formData = {
        id: this.$store.state.forms.length + 1,
        name: this.name,
        title: this.title,
        viewer_url: this.viewer_url,
        status: this.status,
        revisionDate: new Date(this.revisionDate),
        expirationDate: new Date(this.expirationDate),
        version: this.version,
        primaId: this.primaId,
        practiceArea: this.practiceArea,
        enableForQuestionnaire: this.enableForQ,
        practiceAreaSection: this.practiceAreaSection,
        pages: this.jsonData.pages,
        properties: {
          role1: this.role1._id !== undefined ? this.role1._id : '',
          prefix1: this.prefix1,
          role2: this.role2._id !== undefined ? this.role2._id : '',
          prefix2: this.prefix2,
          role3: this.role3._id !== undefined ? this.role3._id : '',
          prefix3: this.prefix3,
          role4: this.role4._id !== undefined ? this.role4._id : '',
          prefix4: this.prefix4,
          role5: this.role5._id !== undefined ? this.role5._id : '',
          prefix5: this.prefix5,
          role6: this.role6._id !== undefined ? this.role6._id : '',
          prefix6: this.prefix6,
          role7: this.role7._id !== undefined ? this.role7._id : '',
          prefix7: this.prefix7,
          role8: this.role8._id !== undefined ? this.role8._id : '',
          prefix8: this.prefix8
        },
        maxItems: this.allRolesMaxItems,
        practiceAreaTag: this.practiceAreaTag,
        internalTag: this.internalTag
      }

      this.invalidFields = []

      if (
        formData.name === '' ||
        formData.viewer_url === '' ||
        formData.title === ''
      ) {
        window.vueBus.emit('addNotification', {
          title: 'New Form',
          body: 'Incomplete information.',
          type: 'warm'
        })
      } else {
        const apiUrl = this.$store.state.apiUrl

        if (
          formData.pages === undefined ||
          formData.pages === null ||
          formData.pages.length === 0
        ) formData.noData = true

        this.axios.post(apiUrl + 'form/add', formData).then(response => {
          this.$bus.emit('getFormList')
          this.handleAddForm(formData, response)
        })
      }
    },

    handleAddForm (formData, response) {
      if (response.data.success) {
        // console.log('FormId', response.data.formId)

        this.globalTemplate.formId = response.data.formId
        formData['_id'] = response.data.formId
        this.$store.commit('addForm', formData)
        this.uploadDefaultTemplate()
      } else {
        const errorData = response.data.message

        if (errorData.name === 'ValidationError') {
          this.invalidFields = Object.keys(errorData.errors)

          for (const key in errorData.errors) {
            if (errorData.errors.hasOwnProperty(key)) {
              const error = errorData.errors[key]
              let errorTitle = 'Input Error'
              let errorBody = ''
              if (error.kind === 'minlength') {
                errorTitle = key.toUpperCase() + ' Length Error'
                errorBody = key.toUpperCase() + ' must be at least 2 characters.'
              }

              if (!errorBody.length) {
                errorTitle = 'Validation Error: ' + error.kind
                errorBody = error.message
              }

              this.$bus.emit('addNotification', {
                title: errorTitle,
                body: errorBody,
                type: 'error'
              })
            }
          }
        }
      }
      this.$store.commit('setLastSaved', Date.now())
    },

    setPracticeAreaSections (e) {
      this.$store.state.practiceAreas.forEach(practiceArea => {
        if (e.target.value === practiceArea.name) this.practiceAreaSections = practiceArea.sections
      })

      if (this.practiceAreaSections !== undefined) this.practiceAreaSection = this.practiceAreaSections[0]
    },

    selectPracticeAreaSection (section) {
      if (section === this.practiceAreaSection) return true
    },

    showMaxItemsModal (role) {
      this.currentRole = ''
      this.maxItems = this.allRolesMaxItems[role]
      this.isMaxItemsModal = true

      this.currentRole = role
    },

    updateMaxItems (maxItems) {
      this.allRolesMaxItems[this.currentRole] = maxItems
    }
  }
}
</script>

<style lang="scss" scoped>
  #addFormModal {
    position: fixed;
    top: 5%;
    left: 50%;
    margin-left: -40%;
    width: 80%;
    height: 80%;
    z-index: 1050;
    overflow: hidden;
    outline: 0;

    background-color: #eee;
    border: 1px solid black;
    border-radius: 5px;
    padding: 0;

    .header {
      background-color: #2d5f8b;
      color: white;
      font-size: 18px;
      padding: 5px 10px 5px 10px;

      .btn-close {
        cursor: pointer;
        color: #FFF;
        font-size: 34px;
        font-weight: bold;
        line-height: 24px;
      }
    }


    .forms-wrapper {
      overflow-y: scroll;
      width: 100%;
      height: 100%;
      padding: 15px;
    }

    .invalid {
      border: 2px solid red;
    }

    .scroll-padding {
      display: block;
      width: 100%;
      height: 50px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/form-grid/AddFormModal.vue